//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AddFolderToSearch",1,0],[0,"DefineBy",1,0],[0,"DeleteOldComponentsToggle",1,0],[0,"ExportDrawingFile",1,0],[0,"ListChildrenComponents",1,0],[0,"LoadOption",1,0],[0,"NeedChangeDisplayPartBack",1,0],[0,"NewNameRule",1,0],[0,"NewStringInName",1,0],[0,"NextPartNameNumber",1,0],[0,"OldStringInName",1,0],[0,"OutputDiretory",1,0],[0,"PartDirectory",1,0],[0,"PrefixOrSuffixString",1,0],[0,"SelectAssemblyInFolder",1,0],[1,"SelectAssemblyToExport",0,"SelectNXObject",0],[1,"SelectComponentToRename",0,"SelectNXObjectList",0],[0,"ToolingNameRule",1,0],[0,"Type",1,0],[0,"WizardType",1,0]],[[["partTag","dirName","newPartName"],"RenameComponents",{},3,0],[["folderList"],"SetSearchFolderListForExportDrawingFiles",{},1,0],[["partTag","assemblyInFolderWithPath","outputDir"],"ExportComponents",{},3,0],[["assemblyPartNameWithPath","outputDir"],"ExportSingleComponent",{},2,0],[["assemblyPartToExport","assemblyInFolderWithPath","outputDir","onlyGetDrawingFilesNotExport","numDrawingFiles","drawingFilesNeedExport"],"GetDrawingFilesInFolder",{},4,0],[["componentTag","newComponentNameWithPath"],"ReplaceComponent",{},2,0]],[]];
SPLM.Tooling.RenameAndExportComponentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.RenameAndExportComponentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.RenameAndExportComponentBuilder.NamingRuleType = Object.freeze({
    "None" : "None", "Prefix" : "Prefix", "Suffix" : "Suffix", "ReplaceString" : "ReplaceString", "ToolingNameRule" : "ToolingNameRule"});

SPLM.Tooling.RenameAndExportComponentBuilder.NameRuleType = Object.freeze({
    "Default" : "Default"});

SPLM.Tooling.RenameAndExportComponentBuilder.Types = Object.freeze({
    "RenameCompoent" : "RenameCompoent", "ExportAssembly" : "ExportAssembly"});

SPLM.Tooling.RenameAndExportComponentBuilder.DefinitionType = Object.freeze({
    "Directory" : "Directory", "RootPart" : "RootPart", "Selection" : "Selection"});

SPLM.Tooling.RenameAndExportComponentBuilder.LoadOptionType = Object.freeze({
    "FromFolder" : "FromFolder", "FromSearchFolder" : "FromSearchFolder"});

export default SPLM;